(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const MARKER_SELECTOR = '[data-mg-product-reveal]';
    const INITIALIZED_ATTRIBUTE = 'data-mg-product-initialized';
    const COMPLETED_ATTRIBUTE = 'data-mg-product-completed';

    const animationClasses = [
      'mg-product-reveal',
      'mg-product-reveal--fade-up',
      'mg-product-reveal--fade-left',
      'mg-product-reveal--fade-right',
      'mg-product-reveal--zoom',
      'mg-product-reveal--fade',
      'mg-product-reveal--visible'
    ];

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    const getNumber = (value, fallback) => {
      const parsedValue = Number.parseInt(value, 10);

      return Number.isFinite(parsedValue)
        ? parsedValue
        : fallback;
    };

    const getAnimationTarget = (marker) => {
      return (
        marker.closest('.product-grid__item') ||
        marker.closest('[data-product-id]') ||
        marker.closest('product-card') ||
        marker.parentElement
      );
    };

    const getProductPosition = (target) => {
      const parent = target.parentElement;

      if (!parent) return 0;

      const siblings = Array.from(parent.children).filter((element) => {
        return (
          element.matches('.product-grid__item') ||
          element.matches('[data-product-id]') ||
          element.matches('product-card')
        );
      });

      const position = siblings.indexOf(target);

      return position >= 0 ? position : 0;
    };

    const removeAnimationStyles = (target) => {
      animationClasses.forEach((className) => {
        target.classList.remove(className);
      });

      target.style.removeProperty('--mg-product-duration');
      target.style.removeProperty('--mg-product-delay');
      target.style.removeProperty('--mg-product-distance');

      target.setAttribute(COMPLETED_ATTRIBUTE, 'true');
    };

    /*
     * The observer reveals each product only when it enters the viewport.
     */
    const productObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const target = entry.target;

          const duration = getNumber(
            target.dataset.mgProductDuration,
            700
          );

          const delay = getNumber(
            target.dataset.mgProductDelay,
            0
          );

          /*
           * Two frames guarantee that the hidden starting position
           * renders before the visible class is applied.
           */
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              target.classList.add(
                'mg-product-reveal--visible'
              );
            });
          });

          observer.unobserve(target);

          /*
           * Remove animation classes after completion so the animation
           * does not interfere with the theme's existing hover effects.
           */
          window.setTimeout(() => {
            removeAnimationStyles(target);
          }, duration + delay + 180);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -30px 0px'
      }
    );

    const prepareProduct = (marker) => {
      if (marker.dataset.animationEnabled !== 'true') return;

      const target = getAnimationTarget(marker);

      if (!target) return;

      if (
        target.hasAttribute(INITIALIZED_ATTRIBUTE) ||
        target.hasAttribute(COMPLETED_ATTRIBUTE)
      ) {
        return;
      }

      target.setAttribute(INITIALIZED_ATTRIBUTE, 'true');

      if (reducedMotion.matches) {
        target.setAttribute(COMPLETED_ATTRIBUTE, 'true');
        return;
      }

      const animationStyle =
        marker.dataset.animationStyle || 'fade-up';

      const duration = getNumber(
        marker.dataset.animationDuration,
        700
      );

      const stagger = getNumber(
        marker.dataset.animationStagger,
        100
      );

      const distance = getNumber(
        marker.dataset.animationDistance,
        30
      );

      const productPosition = getProductPosition(target);

      /*
       * The stagger restarts after eight products.
       * This prevents lower rows from waiting several seconds.
       */
      const staggerPosition = productPosition % 8;
      const delay = staggerPosition * stagger;

      target.style.setProperty(
        '--mg-product-duration',
        `${duration}ms`
      );

      target.style.setProperty(
        '--mg-product-delay',
        `${delay}ms`
      );

      target.style.setProperty(
        '--mg-product-distance',
        `${distance}px`
      );

      target.dataset.mgProductDuration = String(duration);
      target.dataset.mgProductDelay = String(delay);

      target.classList.add(
        'mg-product-reveal',
        `mg-product-reveal--${animationStyle}`
      );

      productObserver.observe(target);
    };

    const scanProducts = (root = document) => {
      const markers = [];

      if (
        root instanceof Element &&
        root.matches(MARKER_SELECTOR)
      ) {
        markers.push(root);
      }

      if (root.querySelectorAll) {
        markers.push(
          ...root.querySelectorAll(MARKER_SELECTOR)
        );
      }

      markers.forEach((marker) => {
        prepareProduct(marker);
      });
    };

    /*
     * Product grids can be replaced after filtering, sorting,
     * pagination or infinite scrolling. Observe new DOM content and
     * initialize only the newly added products.
     */
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          scanProducts(node);
        });
      });
    });

    const mutationRoot =
      document.querySelector('main') ||
      document.body;

    if (mutationRoot) {
      mutationObserver.observe(mutationRoot, {
        childList: true,
        subtree: true
      });
    }

    /*
     * Reinitialize products when Shopify reloads a section
     * inside the theme editor.
     */
    document.addEventListener(
      'shopify:section:load',
      (event) => {
        scanProducts(event.target);
      }
    );

    /*
     * Immediately reveal a card selected in the theme editor.
     */
    document.addEventListener(
      'shopify:block:select',
      (event) => {
        const marker =
          event.target.matches?.(MARKER_SELECTOR)
            ? event.target
            : event.target.querySelector?.(MARKER_SELECTOR);

        if (!marker) return;

        const target = getAnimationTarget(marker);

        if (!target) return;

        target.classList.add(
          'mg-product-reveal--visible'
        );
      }
    );

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => scanProducts(document),
        { once: true }
      );
    } else {
      scanProducts(document);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
